/** Paths that must not boot authenticated app providers or their APIs. */
export function isPublicIsolatedPath(pathname = window.location.pathname): boolean {
  return (
    pathname.startsWith("/business-onboarding/") ||
    pathname.startsWith("/business-proposal/") ||
    pathname.startsWith("/forms/consultation/") ||
    pathname.startsWith("/forms/register/") ||
    pathname.startsWith("/consultationform/") ||
    pathname.startsWith("/website/microsite/")
  );
}
